exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div[data-v-576a5c2e]{cursor:pointer}.inactive[data-v-576a5c2e]{opacity:.5}", ""]);

// exports
